import { Controller } from 'stimulus';
import {showElement, hideElement} from '~/helpers/animations_helpers';

export default class extends Controller {
  static targets = ['element', 'icon', 'hidden'];

  toggleElement() {
    if(this.hiddenTarget.classList.contains('hidden')) {
      this.iconTarget.classList.add('rotate-180')
      showElement(this.hiddenTarget)
    } else {
      this.iconTarget.classList.remove('rotate-180')
      hideElement(this.hiddenTarget)
    }
  }
}
